import { render, staticRenderFns } from "./SchemeItem.vue?vue&type=template&id=363adff6&scoped=true&"
import script from "./SchemeItem.vue?vue&type=script&lang=js&"
export * from "./SchemeItem.vue?vue&type=script&lang=js&"
import style0 from "./SchemeItem.vue?vue&type=style&index=0&id=363adff6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363adff6",
  null
  
)

export default component.exports